export default __webpack_public_path__ + "static/media/5.0b681e5e.png";